export default __webpack_public_path__ + "static/media/plus_white.6fa82950.svg";